import { TriggerSource } from '../api'

/** How a capture was started: the weight gate, the button, the local API
 *  (phone UI / CoreInk), or nothing recorded
 *  (manual catch logs, firmware that predates the field). Always renders, so
 *  "none" is visible rather than a blank. */
export default function TriggerChip({ source }: { source: TriggerSource | null | undefined }) {
  const cls = source === TriggerSource.Weight
    ? 'text-gold border-gold/40'
    : source === TriggerSource.Button
      ? 'text-stone-700 border-stone-300'
      : source === TriggerSource.Api
        ? 'text-pine border-pine/40'
        : 'text-stone-400 border-stone-200'
  return (
    <span
      title={source ? `Triggered by ${source}` : 'No trigger source recorded'}
      className={`inline-block font-mono text-[9px] tracking-[0.15em] uppercase px-1.5 py-0.5 rounded border leading-none ${cls}`}
    >
      {source ?? 'none'}
    </span>
  )
}
